/* SANTOS — color swatches on product cards
   Tap a color dot: the card switches to that color in place (photo, name, price, link).
   Tap anywhere else on the card: go to the product page of the color shown. */
(function () {
  'use strict';

  // Collect every color version of a card once: { productId: innerHTML }
  function versions(card) {
    if (card.__versions) return card.__versions;
    var map = {};
    card.querySelectorAll('template[data-swatch-card]').forEach(function (t) {
      var inner = t.content.querySelector('[data-product-card]');
      if (inner) map[t.getAttribute('data-swatch-card')] = inner.innerHTML;
      t.remove();
    });
    map[card.getAttribute('data-card-product')] = card.innerHTML;
    card.__versions = map;
    return map;
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.color-swatches--card [data-swatch-product]');
    if (!sw) return;
    var card = sw.closest('[data-product-card]');
    if (!card) return;
    e.preventDefault();
    e.stopPropagation();
    var id = sw.getAttribute('data-swatch-product');
    if (id === card.getAttribute('data-card-product')) return;
    var map = versions(card);
    if (!map[id]) { window.location.href = sw.href; return; }
    card.innerHTML = map[id];
    card.setAttribute('data-card-product', id);
  }, true);

  // Desktop: hovering a dot previews that color's photo
  if (!window.matchMedia('(hover: hover)').matches) return;
  function img(card) { return card && card.querySelector('.product-card__image--primary'); }
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('.color-swatches--card [data-swatch-image]');
    if (!sw) return;
    var card = sw.closest('[data-product-card]');
    if (!card) return;
    versions(card); // snapshot the untouched card before previewing
    var i = img(card);
    if (!i) return;
    if (!i.__orig) i.__orig = { src: i.src, srcset: i.getAttribute('srcset') };
    i.removeAttribute('srcset');
    i.src = sw.getAttribute('data-swatch-image');
  });
  document.addEventListener('mouseout', function (e) {
    var list = e.target.closest('.color-swatches--card');
    if (!list || list.contains(e.relatedTarget)) return;
    var i = img(list.closest('[data-product-card]'));
    if (!i || !i.__orig) return;
    i.src = i.__orig.src;
    if (i.__orig.srcset) i.setAttribute('srcset', i.__orig.srcset);
  });
})();
